import { checkIsNoNeedDateSelect } from "./methods/checkIsNoNeedDateSelect";
import { checkIsValidDate } from "./methods/checkIsValidDate";
import { checkIsPriceCalendar } from "./methods/checkIsPriceCalendar";
import { checkIsClosedCalendar } from "./methods/checkIsClosedCalendar";

export default {
  checkIsNoNeedDateSelect,
  checkIsValidDate,
  checkIsPriceCalendar,
  checkIsClosedCalendar,
};
